module.exports = __webpack_public_path__ + "img/2021_20210207_122955.f5e5ef04.jpg";